import { eventTracker } from 'app/modules/Segment';
import {
  FeatureEnum,
  GroupIdEnum,
  OwnerEnum,
  TProperties,
  TContext,
} from 'app/modules/Segment/types';

interface CalculationEventProperties {
  feature?: string;
  owner?: string;
  relevant_user_activity?: boolean;
  event_meaning?: string;
  isUniversal?: boolean;
  type?: string;
  [key: string]: unknown;
}

interface CalculationContext {
  groupId?: string;
  library?: {
    name?: string;
    componente?: string;
  };
}

const DEFAULT_PROPERTIES: Partial<TProperties> = {
  feature: FeatureEnum.CALCULATOR,
  owner: OwnerEnum.JUSCALC,
  relevant_user_activity: true,
};

const DEFAULT_CONTEXT: TContext = {
  groupId: GroupIdEnum.JUSCALC_GROUP,
  library: {
    name: 'juscalc-library',
    componente: 'calculator',
  },
};

export const trackCalculationEvent = (
  event: string,
  customProperties?: CalculationEventProperties,
  customContext?: CalculationContext,
) => {
  const properties: TProperties = {
    ...DEFAULT_PROPERTIES,
    ...customProperties,
    // ponytail: fallback anti-crash — o nome do evento não é o significado dele, só evita o `throw`
    // do Zod quando o caller omite. Significado de verdade vem com o `FeatureEnum` na DT de
    // taxonomia; até lá os call sites que não passam `event_meaning` emitem significado pobre.
    event_meaning: customProperties?.event_meaning || event,
  } as TProperties;

  const context: TContext = {
    ...DEFAULT_CONTEXT,
    ...customContext,
    library: {
      ...DEFAULT_CONTEXT.library,
      ...customContext?.library,
    },
  };

  eventTracker.track({
    event,
    properties,
    context,
  });
};
